import React from "react";
import { useSelector } from "react-redux";
import { selectAllFormSettings } from "../redux/slices/formSettingsSlice";
import {
    selectAllRegistration,
    updateRegistration,
} from "../redux/slices/registrationSlice";
import { selectAllP2pSettings } from "../redux/slices/p2pSettingsSlice";
import {
    selectErroredEntities,
    selectOutdated,
    setOutdated,
    setErroredEntities,
    setUnsetSelectedClassification,
} from "../redux/slices/raceConditionsSlice";
import { updateCategories } from "../redux/slices/categoriesSlice";
import { updateClassifications } from "../redux/slices/classificationsSlice";
import { updateProducts } from "../redux/slices/productsSlice";
import { selectTeams, updateTeams } from "../redux/slices/teamsSlice";
import { selectCurrentPage } from "../redux/slices/currentPageSlice";
import UpdateOutdated from "./UpdateOutdated";

const ConnectedUpdateOutdated = () => {
    const currentPage = useSelector(selectCurrentPage);
    const erroredEntities = useSelector(selectErroredEntities);
    const formSettings = useSelector(selectAllFormSettings);
    const outdated = useSelector(selectOutdated);
    const registration = useSelector(selectAllRegistration);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const teamsList = useSelector(selectTeams);

    const { id } = formSettings;
    const { classification = {}, registrations = [] } = registration;
    const { limitTeamJoiningToClassification } = p2pSettings;

    const hasClassification =
        Object.keys(classification).length > 0 &&
        classification.Classification &&
        classification.Classification[0];

    const classificationId =
        hasClassification && limitTeamJoiningToClassification
            ? Number(classification.Classification[0])
            : 0;

    const updateOutdatedProps = {
        classificationId,
        currentPage,
        erroredEntities,
        formId: id,
        outdated,
        registrations,
        setErroredEntities,
        setOutdated,
        setUnsetSelectedClassification,
        teamsList,
        updateCategories,
        updateClassifications,
        updateProducts,
        updateRegistration,
        updateTeams,
    };

    return <UpdateOutdated {...updateOutdatedProps} />;
};

export default ConnectedUpdateOutdated;
